/* eslint-disable */
import Flex from 'components/Flex';
import SidebarPage from 'components/SidebarPage';
import Header from 'modules/Layouts/Components/Partials/Header';
import Nav from 'modules/Nav/Container/index';
import React, { useLayoutEffect } from 'react';
import styled, { css } from 'styled-components';
import { COLORS } from 'theme';
import { useLocation } from 'react-router-dom';

const BREAKPOINT = '999px';

const ContentWrapper = styled(Flex)`
overflow-y: auto;
margin-bottom: 0%;
&::-webkit-scrollbar {
  width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #cccccc;
    }
    
    ${({ isAssessment }) =>
    !isAssessment &&
    css`
        border-radius: 10px;
      box-shadow: 0px 4px 12px rgba(153, 153, 153, 0.35);
      border: 1px solid ${COLORS.PAGE_BORDER};
    `}
`;

const PageWrapper = styled(Flex)`
  ${({ isAssessment }) =>
    !isAssessment &&
    css`
      background: '#FFFFFF';
      height: 100vh;
      min-height: 100vh;
    `}
  flex-direction: column;

  flex-grow: 1;
  @media screen and (max-width: ${BREAKPOINT}) {
    padding: 0px;
    overflow-x: hidden;
    box-sizing: border-box;
  }
`;

const Page = ({
  children,
  corporateDetails,
  corporateData,
  userData,
  getUserInfo,
  roleList,
  getRoles,
  getUserPermissions,
}) => {
  const location = useLocation();
  const isAssessment = location.pathname.includes('/assessment');

  useLayoutEffect(() => {
    getUserInfo();
    getRoles();
  }, []);

  useLayoutEffect(() => {
    if (userData?.admin_role_id !== undefined) {
      getUserPermissions(userData?.admin_role_id);
    }
  }, [userData]);

  return (
    <PageWrapper isAssessment={isAssessment}>
      <Header
        corporateData={corporateData}
        userData={userData}
        roleList={roleList}
        getRoles={getRoles}
        getUserInfo={getUserInfo}
      />
      <Flex>
        <Nav />
        <SidebarPage>
          <ContentWrapper isAssessment={isAssessment} column>
            {children}
          </ContentWrapper>
        </SidebarPage>
      </Flex>
    </PageWrapper>
  );
};

export default Page;
